import { showModalInfo } from "./ViewHelpers";
import locales_es from "../locales/es";

class Helpers {
  validateEmail(email) {
    if (!email || typeof email !== "string") return false;
    let reg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return reg.test(email);
  }

  /*
   * Takes an Integer and returns a String as a "24hs." format.
   * */
  getTwentyFourFormatAsString(int) {
    return String(int < 10 ? "0" + int : int);
  }

  /*
   * TIME HTML PARSING
   * Takes a event date and returns it as a parsed custom html format output
   * */
  parseEventTime(eventDate, isAmPm, hasToAddStrings, utcOn) {
    const date = new Date(eventDate);

    let result = "";

    const hours = this.getTwentyFourFormatAsString(
      utcOn ? date.getUTCHours() : date.getHours()
    );
    const minutes = this.getTwentyFourFormatAsString(
      utcOn ? date.getUTCMinutes() : date.getMinutes()
    );

    const parsedTime = this.parseTime(
      hours + ":" + minutes,
      isAmPm,
      hasToAddStrings
    );

    result += parsedTime.hours + "";
    result += ":" + parsedTime.minutes;

    return result;
  }

  /*
   * Takes a time string and returns it as a JSON object
   * */
  parseTime(timeToParse, isAmPm, hasToAddStrings) {
    if (!timeToParse) {
      return {};
    }

    // Ejemplo de un string de tiempo: "09:00:00"
    const hours = timeToParse.substr(0, 2); // 09
    const minutes = timeToParse.substr(3, 2); // 00
    if (isAmPm) {
      const ampm = hasToAddStrings ? (hours > 11 ? " PM" : " AM") : "";
      return {
        hours: hours % 12 || 12, // converts to correct hours am/pm,
        minutes: minutes + ampm,
      };
    } else {
      const hs = hasToAddStrings ? "hs." : "";
      return {
        hours: hours,
        minutes: minutes + hs,
      };
    }
  }

  /*
   *
   * Utility to get ErrorMessages from ApiService responses
   */
  /*getErrorMsg(err) {
		if(err.response && err.response.status && err.response.status === 500) {
			return 'Contáctate con el administrador por favor para que podamos ayudarte.'
		}

		return err.response && err.response.data && err.response.data.message
		  ? err.response.data.message : err.message;
	}*/
  getErrorMsg(err) {
    const defaultUnexpectedMsg =
      locales_es?.errorModal?.unexpectedErrorHasOcurred ||
      "Ha ocurrido un error inesperado. Por favor, intente nuevamente en unos minutos.";

    if (!err) {
      return defaultUnexpectedMsg;
    }

    const response = err.response;
    const status = response?.status;
    const data = response?.data;

    // 1. Si el backend envió error_message explícito (ej: error mapeado de QBI o respuesta controlada)
    if (data && typeof data.error_message === "string" && data.error_message.trim()) {
      return data.error_message;
    }

    // 2. Si vienen errores de validación estructurados (ej: Laravel 422 errors)
    if (data && data.errors && typeof data.errors !== "string") {
      const errorList = Array.isArray(data.errors)
        ? data.errors
        : Object.values(data.errors).flat();

      if (errorList.length) {
        return errorList.filter(Boolean).join(". ");
      }
    }

    // 3. Si el status es de cliente/controlado (< 500) y viene un mensaje válido no técnico
    if (status && status < 500 && data && typeof data.message === "string" && data.message.trim()) {
      const msg = data.message.replace(/^Error:\s*/, "");
      const technicalPatterns = [
        /^Server Error$/i,
        /^Unauthenticated\.$/i,
        /^Unauthorized$/i,
        /^Internal Server Error$/i,
      ];
      const isTechnical = technicalPatterns.some((pattern) => pattern.test(msg.trim()));
      if (!isTechnical) {
        return msg;
      }
    }

    // 4. Si viene referencia de soporte (Sentry ID u error_reference)
    const ref = data?.error_reference;
    if (ref) {
      return `${defaultUnexpectedMsg} (Ref: ${ref})`;
    }

    // 5. Fallback unificado para errores 500, network errors o no contemplados
    return defaultUnexpectedMsg;
  }

  processError(err) {
    if (
      (err && err.response && err.response.status == 401) ||
      err.response.status == 403
    ) {
      return;
    }
    showModalInfo(locales_es.errorModal.title, this.getErrorMsg(err));
  }

  /*
   *
   * Utility to check if a profile is complete
   */
  profileValidator(profile) {
    return !profile.address || !profile.medical_license_id;
  }

  licenseValidator(license) {
    if (license) {
      return (
        !license.profession ||
        (license.country_id === 1 && !license.medical_licenses_type) ||
        (!license.medical_licenses_jurisdiction &&
          license.medical_licenses_type &&
          license.medical_licenses_type.code != "MN") ||
        ((license.country_id === 1 || license.country_id === 3) && !license.identification) ||
        license.source === null
      );
    } else {
      return false;
    }
  }

  identificationImageValidator(user) {
    const imagenUrl = user.full_identification_image;
    const nombreImagen = imagenUrl ? imagenUrl.split("/").pop() : "";
    return (nombreImagen == 'user.png' || !imagenUrl);
  }

  /*
   *
   * Method to detect mobile devices
   */
  isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  }

  isAndroid() {
    return /Android/i.test(navigator.userAgent);
  }

  isIOS() {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
  }

  /*
   *
   * Method to detect we are on app.rcta.me, and that we are not a custom clinic frontend.
   */
  isRCTAApp() {
    const regex =
      /app.rcta.me|app.dev.rcta.me|app.qa.rcta.me|app.stg.rcta.me|app-temp|app.hml.rcta.me|app-tmp.rcta.me|rctaweb.woopi.com.ar|localhost|3001/gm;
    if (regex.test(window.location.port)) {
      return false;
    }
    return regex.test(window.location.hostname);
  }

  openLink(url) {
    return new Promise((resolve, reject) => {
      try {
        window.open(url, "_blank");
        resolve();
      } catch (err) {
        reject(err);
      }
    });
  }
}

//unregister();

export default Helpers;
